import React, { useContext, useEffect } from 'react'
import AddSubcategory from '../../components/AddProducts/AddSubcategory'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { useCategory } from '../../hooks/Features/useCategory'
import { useFeatures } from '../../hooks/Features/useFeatures'
import { isArray, ROUTES, uploadFilesToAws } from '../../shared/constants'

function SubCategory({ subcategory }) {
  const { getAllCategories } = useCategory()
  const { addsubCategory, updatesubCategory } = useFeatures()
  const { categories } = useContext(CategoryContext)

  const [subcategoryForm, setSubcategoryForm] = React.useState({
    selectCategory: '',
    subCategoryName: '',
    description: '',
    subcategoryCode: '',
    active: true,
  })
  const handleSubCategory = async () => {
    let location = subcategoryForm.file
    if (!isArray(subcategoryForm.file)) {
      location = await uploadFilesToAws(subcategoryForm.file)
    }
    if (subcategory) {
      await updatesubCategory({
        ...subcategoryForm,
        categoryId: subcategoryForm.selectCategory,
        name: subcategoryForm.subCategoryName,
        description: subcategoryForm.description,
        image: location[0],
        subcategoryCode: subcategoryForm.subcategoryCode,
        subCategoryId: subcategory._id,
      })
    } else {
      await addsubCategory({
        ...subcategoryForm,
        categoryId: subcategoryForm.selectCategory,
        name: subcategoryForm.subCategoryName,
        description: subcategoryForm.description,
        image: location? location[0] : "",
        subcategoryCode: subcategoryForm.subcategoryCode,
      })
    }
  }

  useEffect(() => {
    getAllCategories()
  }, [])
  useEffect(() => {
    if (subcategory) {
      setSubcategoryForm({
        ...subcategoryForm,
        selectCategory: subcategory.categoryId && subcategory.categoryId._id,
        subCategoryName: subcategory.name,
        description: subcategory.description,
        file: [subcategory.image],
        subcategoryCode: subcategory.subcategoryCode,
      })
    }
  }, [subcategory])
  return (
    <Layout heading="SubCategory" heading2="Add" url1={ROUTES.SUBCATEGORIES} none>
      <HeaderTabLayout
        heading="Add SubCategory"
        content={<AddSubcategory state={subcategoryForm} setState={setSubcategoryForm} categories={categories} />}
        addContent={handleSubCategory}
        redirect={ROUTES.SUBCATEGORIES}
        state={subcategoryForm} setState={setSubcategoryForm}
      />
    </Layout>
  )
}

export default SubCategory
